<template>
  <div>
    <h3>
      {{ titleobj.projectLeaderName }}负责的项目【{{ titleobj.name }}】已开始{{
        titleobj.useTime
      }}天，当前进度 “{{ titleobj.stateName }}”
    </h3>
    <div class="tab-list">
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div v-for="(v, k) in menus" style="display: inline-block" :key="k">
            <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <div class="addcontract">
      <Button type="info" ghost @click="this.toAdd">新增合同</Button>
    </div>
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <Table
        :columns="tableCols"
        :data="data2"
        :table="table"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
        style="width: 100%"
      >
      </Table>
    </Row>
  </div>
</template>

<script>
import config from "../../../../config";
let customerId = window.localStorage.getItem("customerId");
export default {
  data() {
    return {
      titleobj: {},
      button: "",
      desc: "",
      value: false,
      menus: [
        {
          label: "项目全景",
          name: "panorama",
        },
        {
          label: " 跟进记录",
          name: "schedule_Info",
        },
        {
          label: "任务",
          name: "task_Info",
        },
        {
          label: Number(customerId) == 0 ? "客户" : "供应商",
          name: "supplier_List",
        },
        {
          label: "合同",
          name: "contract_Info",
        },
        {
          label: "发票/支付",
          name: "invoice_Info",
        },
      ],
      table: {
        mname: "",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 70,
          align: "center",
        },
        {
          title: "类型",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.type === 1
                ? "购销合同"
                : row.type === 2
                ? "服务合同"
                : row.type === 3
                ? "维保合同"
                : "";
            return h(
              "div",
              {
                style: {
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "合同名称",
          key: "name",
          width: "300px",
          align: "left",
          tooltip: "true",
        },
        {
          title: "签订日期",
          key: "moveStart",
          minWidth: 110,
          align: "left",
          tooltip: "true",
        },
        {
          title: "预交付日期",
          key: "moveEnd",
          minWidth: 110,
          align: "left",
        },
        {
          title: "合同起始日",
          key: "contractStartTime",
          minWidth: 110,
          align: "left",
          tooltip: "true",
        },
        {
          title: "合同终止日",
          key: "contractEndTime",
          minWidth: 110,
          align: "left",
        },
        {
          title: "金额(元)",
          minWidth: 100,
          align: "center",
          align: "center",
          key: "totalMoney",
          render: (h, params) => {
            const row = params.row;
            const budget = row.totalMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        {
          title: "招标文件",
          minWidth: 110,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            if (row.biddingDocumentUrl !== null) {
              const text = row.biddingDocumentUrl;
              return (
                <svg
                  onClick={() => {
                    this.handleRender(text);
                  }}
                  t="1686795127586"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7800"
                  width="20"
                  height="20"
                >
                  <path
                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                    fill="#CCA352"
                    p-id="7801"
                  ></path>
                  <path
                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                    fill="#FFFFFF"
                    p-id="7802"
                  ></path>
                  <path
                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                    fill="#FFCC66"
                    p-id="7803"
                  ></path>
                </svg>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "合同文件",
          minWidth: 110,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            if (row.pdfpath !== null) {
              const text = row.pdfpath;
              return (
                <svg
                  onClick={() => {
                    this.handleRender(text);
                  }}
                  t="1686795127586"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7800"
                  width="20"
                  height="20"
                >
                  <path
                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                    fill="#CCA352"
                    p-id="7801"
                  ></path>
                  <path
                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                    fill="#FFFFFF"
                    p-id="7802"
                  ></path>
                  <path
                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                    fill="#FFCC66"
                    p-id="7803"
                  ></path>
                </svg>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "验收文件",
          minWidth: 110,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            if (row.ar !== null) {
              const text = row.ar;
              return (
                <svg
                  onClick={() => {
                    this.handleRender(text);
                  }}
                  t="1686795127586"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7800"
                  width="20"
                  height="20"
                >
                  <path
                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                    fill="#CCA352"
                    p-id="7801"
                  ></path>
                  <path
                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                    fill="#FFFFFF"
                    p-id="7802"
                  ></path>
                  <path
                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                    fill="#FFCC66"
                    p-id="7803"
                  ></path>
                </svg>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          fixed: "right",
          render: (vm, param) => {
            const row = param.row;
            return (
              <div>
                <Button
                  size="small"
                  onClick={() => this.toEdit(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  编辑
                </Button>
                <Button
                  size="small"
                  onClick={() => this.delItem(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  删除
                </Button>
                <Button
                  size="small"
                  onClick={() => this.invoicelist(row)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  发票
                </Button>
              </div>
            );
          },
          auth: {
            edit: "/maintainer/maintainer/sysTask/edit",
          },
        },
      ],
      data2: [],
      menu_name: "",
      projectId: window.localStorage.getItem("projectId"),
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.load(this.projectId);
    this.initData(this.projectId);
  },
  methods: {
    handleRender(text) {
      console.log(text);
      
      if (!text) {
        $utils.toast.error("暂无文件!");
        return;
      }
      const texturl = text.split(",").map((url) => config.IMAGE_HOST + url);
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `查看附件`,
        width: "500px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              {files.map((item, i) => (
                <div
                  style="display:flex;justify-content: space-between;border: 1px solid #dcdee2; padding: 10px;border-radius: 5px;"
                  key={i}
                >
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </a>
                </div>
              ))}
            </div>
          );
        },
      });
    },
    async initData(id) {
      if (id) {
        let res = await $utils.api.load(`/admin/system/management/${id}`);
        try {
          if (res.code == 200) {
            this.titleobj = res.data;
            this.menus = [
              {
                label: "项目全景",
                name: "panorama",
              },
              {
                label: " 跟进记录",
                name: "schedule_Info",
              },
              {
                label: "任务",
                name: "task_Info",
              },
              {
                label: Number(customerId) == 0 ? "客户" : "供应商",
                name: "supplier_List",
              },
              {
                label: "合同",
                name: "contract_Info",
              },
              {
                label: "发票/支付",
                name: "invoice_Info",
              },
            ];
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    async load(id) {
      let d = { projectId: id };
      let res = await $utils.api.load(`/admin/system/contract/list`, d, "get");
      if (res.code == 200 && res.rows.length > 0) {
        this.data2 = res.rows;
      }
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    toAdd() {
      $utils.url.push({ name: "add_contract" });
    },
    toEdit(row) {
      $utils.url.push({
        name: "add_contract",
        query: {
          kv: row.id,
          action: "edit",
        },
      });
    },
    async delItem(row) {
      let d = {};
      let res = await $utils.api.load(`/admin/system/contract/${row.id}`, d, "DELETE");
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        setTimeout(() => {
          location.reload();
        }, 1000);
      }
    },
    async invoicelist(row) {
      $utils.url.push({
        name: "invoice_Info",
        query: {
          id: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.addcontract {
  margin-top: 10px;
}
</style>
